import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";

// Actions
import { manualRequestFormActions } from "../../store/actions/vorgange/manualRequestFormActions";

// Components
import ErrorText from "../shared/ErrorText";

// Icons
import AddressProofIcon from "../iconComponents/AddressProofIcon";

// Helper
import { formConstants } from "../../helpers/vorgange";

// Constants
import {
  GeschlechtOptions,
  halterRequestFormConstants,
  ADDRESS_PROOF_CONFIRMATION_LABEL,
  steuerzahlweiseOptions,
  SIGNING_PROCESSING_TYPE,
} from "../../constants/ManualRequestFormConstants";

// Core Component
import DownloadFileIcon from "../iconComponents/DownloadFileIcon";
import VollmachtsRelevantIcon from "../core/VollmachtsRelevantIcon";
import DocumentIcon from "../../assets/images/icon_document.svg";
import carLogo from "../../assets/images/my_digital_car.svg";
import VollmachtLoschen from "./inner_components/VollmachtLoschen";
import MDCCheckbox from "../core/MDCCheckbox";
import MDCText from "../core/MDCText";
import MDCLabel from "../core/MDCLabel";
import MDCDatePicker from "../core/MDCDatePicker";

import { DuplicateTextField } from "./DuplicateControls";

import MDCSelect from "../core/MDCSelect";
import MDCSelectWithTooltip from "../core/MDCSelectWithTooltip";
import MDCGroupedDropdown from "../core/MDCGroupedDropdown";
import MDCGroupedIconDropdown from "../core/MDCGroupedIconDropdown";
import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import { Link } from "@mui/material";
import RepresentativeInfo from "./inner_components/RepresentativeInfo";
import { alertCSS, alertInfoCSS } from "../shared/AlertCSS";
import theme from "../../themes/mdc-theme";
import ZB1ZB2Addresses from "./inner_components/ZB1ZB2Addresses";
import MDCButton from "../core/MDCButton";
import EditIcon from "../iconComponents/EditIcon";
import MDCModal from "../core/MDCModal";
import GlobalMessages from "../shared/GlobalMessages";
import AddressProofUpload from "./inner_components/PassportUpload";
import VollmachtAbbrechen from "./inner_components/VollmachtAbbrechen";
import MDCIBANAutocompleteLookup from "../core/MDCIBANAutocompleteLookup";

// utils
import { dbFormatDate, isVWAGGroup } from "../../helpers/utils";
import { RECHFORM_TYPE_SELF_EMPLOYED_PERSON } from "../../constants/VollmachtsDatenBankConstants";

const styles = () => ({
  alert: alertCSS,
  alertInfo: alertInfoCSS,
  formBackGround: {
    padding: "0 3%",
    paddingTop: "2%",
    marginTop: "2% !important",
    background: `${theme.palette.MDCColors.white} 0% 0% no-repeat padding-box`,
    boxShadow: `0px 3px 6px ${theme.palette.MDCColors.color18}`,
    borderRadius: "5px",
    opacity: 1,
    color: theme.palette.MDCColors.textColor,
    fontSize: "1rem",
    fontFamily: theme.palette.typography.fontFamily,
    lineHeight: 1,
  },
  detailViewBackground: {
    boxShadow: "none",
    paddingTop: "initial",
  },
  vollmachtCompleted: {
    paddingTop: "1%",
  },
  columnTitle: {
    fontSize: "1rem",
    fontWeight: "bold",
    fontFamily: theme.palette.typography.fontFamily,
    marginBottom: "1.25rem",
  },
  fieldGroup: {
    marginBottom: ".5rem !important",
  },
  linkLabel: {
    color: theme.palette.MDCColors.color23,
    cursor: "pointer",
  },
  infoMessage: {
    margin: "1.5rem auto",
  },
  downloadFileIconStyles: {
    color: theme.palette.MDCColors.color23,
    marginRight: "0.7rem",
    marginBottom: "0.34rem",
  },
  linkStyles: {
    fontWeight: "bold !important",
  },
  ppoaInfoBody: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem 2.5rem",
  },
  headerCss: {
    padding: "2rem",
    alignItems: "center",
  },
  headerColor: { color: theme.palette.MDCColors.black },
  contentCss: {
    fontFamily: theme.palette.typography.fontFamily,
    color: theme.palette.MDCColors.color15,
    padding: "0 2rem",
  },
  footerCss: {
    padding: "2rem",
  },
  fieldGroupMargin: {
    "& .MuiFormControl-marginNormal": {
      marginBottom: "0rem !important",
      marginTop: "0.563rem !important",
    },
  },
});
class HalterRequestForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDisconnectPPOAModal: false,
    };
    this.cachedFilteredRechtsformData = null;
    this.cachedFlattenedRechtsformData = [];
    this.cachedHaltertype = null;
    this.cachedRechtsformData = null;
    this.cachedFilteredResult = null;
  }
  getInfoMessage = (message, classes) => {
    const vorgangsart = this.props.vorgangsart.value;

    return (
      !this.props.isDetailDialog &&
      this.props.personenform.value === formConstants.individualPerson &&
      ["NZ", "TZ", "UM", "HA", "WZ", "UG", "WG"].includes(vorgangsart) && (
        <div className={classes.infoMessage}>
          <div className={`${classes.alert} ${classes.alertInfo}`}>
            <span>{message}</span>
          </div>
        </div>
      )
    );
  };

  getPPOAInfoMessage = (message, classes) => {
    const vorgangsart = this.props.vorgangsart.value;

    return (
      !this.props.isDetailDialog &&
      this.props.personenform.value === formConstants.companyPerson &&
      !["AB"].includes(vorgangsart) && (
        <div className={classes.infoMessage}>
          <div
            className={`${classes.alert} ${classes.alertInfo} ${classes.ppoaInfoBody}`}
          >
            <span>{message}</span>
            <Grid>
              <MDCButton
                label={"Bearbeiten"}
                variant={"outlined"}
                onClick={() => {
                  this.setState({ openDisconnectPPOAModal: true });
                }}
                startIcon={<EditIcon color={theme.palette.MDCColors.color23} />}
                removeMarginTop
              />
            </Grid>
          </div>
        </div>
      )
    );
  };
  checkDisabilityForBankDetails = () => {
    const isSteuerbefreiungPresent = this.props?.formValues?.steuerbefreiung
      ?.value
      ? true
      : false;

    if (
      (this.props.formValues.Vorhanden.value &&
        this.props.personenform.value !== "naturliche") ||
      isSteuerbefreiungPresent ||
      this.props.readOnly ||
      this.props.isVollmachtCompleted ||
      this.props?.showVollmachtAbbrechen
    ) {
      return true;
    }
  };

  getHalterAddressTypeOptions = () => {
    const options = [
      {
        label: this.props?.companyDetails?.name,
        value: this.props?.companyDetails?.name,
      }, // LoggedIn User/Tenant Option
      {
        label: "Individuelle Adresse eingeben",
        value: "individuelleAddresse",
      }, //Individual Address Option
    ];

    this.props?.halterFormOperationIds?.map((operationIdDetails) => {
      options.push({
        label: `${operationIdDetails.operationName.value},${operationIdDetails.operationId.value}`,
        value: operationIdDetails.operationId.value,
      }); // Operations Ids Options assigned to that Tenant
    });
    return options;
  };
  // Get File Name For Document
  getFileNameFromHttpResponse = (httpResponse) => {
    return (httpResponse && httpResponse.headers["x-suggested-filename"]) || "";
  };

  handleBlobData = (fileData, fileName) => {
    const url = window.URL.createObjectURL(
      new Blob([fileData], { type: "application/pdf" })
    );

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
  };

  downloadWirtschaftsTemplate = () => {
    this.setState({ anchorProfile: null });
    let fileName, fileData;

    this.props.downloadWirtschaftsPDF().then(() => {
      if (this.props?.wirtschaftsPDF?.status === 200) {
        fileName = this.getFileNameFromHttpResponse(this.props?.wirtschaftsPDF);
        fileData = this.props?.wirtschaftsPDF?.data;
        this.handleBlobData(fileData, fileName);
      }
    });
  };

  getAutoCompleteDropDownValue = (value, optionsArray) => {
    if (value && optionsArray?.length) {
      let dropdownValue = optionsArray?.filter((item) => item?.id === value); //To get the exact object value for AutoCompleteDropdown
      return dropdownValue[0];
    }
  };
  getQESRepresentativeInfoData = () => {
    // We are getting the info in single string separated by "\n" from Back-end so converting it into array list of person data
    if (this.props?.representativeInfo?.length) {
      const representativeArray = this.props.representativeInfo.split("\n");
      return representativeArray;
    }
    return [];
  };

  checkForDisablingVollmachtPPOA = () => {
    if (
      (this.props.formValues.NameJuristischePerson.value === "" &&
        this.props.formValues.halterAddress.value !== "individuelleAddresse") ||
      (this.props.companyDetails?.tenantOwnsGKSNumber &&
        this.props.companyDetails?.name ===
          this.props.formValues.NameJuristischePerson.value) ||
      this.props.readOnly
    ) {
      return true;
    }
    return false;
  };

  checkAddressAndDocumentValidation = () => {
    const { formValues } = this.props;

    const isDocumentMissing =
      !formValues.addressDocument?.value ||
      !formValues.addressDocument?.value?.length;

    const isAnyAddressEmpty = [
      formValues.Strasse?.value,
      formValues.Hausnummer?.value,
      formValues.Postleitzahl?.value,
      formValues.Wohnort?.value,
    ].some((val) => !val || val.trim() === "");

    return isDocumentMissing || isAnyAddressEmpty;
  };

  getGlobalMessagesView = () => {
    const { globalMessages } = this.props;
    return globalMessages?.length &&
      (this.props?.showGlobalMessages || this.props?.isDetailDialog) ? (
      <GlobalMessages
        globalMessages={globalMessages}
        showHeaderLabel={!this.props.isDetailDialog}
      />
    ) : (
      <></>
    );
  };

  checkAddressAndDocumentValidation = () => {
    const { formValues } = this.props;

    const isAnyAddressEmpty = [
      formValues.Strasse?.value,
      ...(this.props.personenform.value === formConstants.companyPerson
        ? []
        : [formValues.Hausnummer?.value]),
      formValues.Postleitzahl?.value,
      formValues.Wohnort?.value,
    ].some((val) => !val || val.trim() === "");

    return isAnyAddressEmpty;
  };

  getFilteredRechtsformData = () => {
    const haltertype = this.props?.formValues?.halterAddress?.value;

    // Filter out "Einzelunternehmen / Selbstständige" for Tenants and Operations
    if (
      haltertype !== "individuelleAddresse" &&
      haltertype !== "" &&
      this.props?.rechtsformData?.length
    ) {
      if (
        this.cachedHaltertype === haltertype &&
        this.cachedRechtsformData === this.props.rechtsformData
      ) {
        return this.cachedFilteredResult;
      }
      this.cachedHaltertype = haltertype;
      this.cachedRechtsformData = this.props.rechtsformData;
      this.cachedFilteredResult = this.props.rechtsformData.filter(
        (item) => item.header !== "Einzelunternehmen / Selbstständige"
      );
      return this.cachedFilteredResult;
    }
    return this.props.rechtsformData;
  };

  getFlattenedRechtsformData = () => {
    const filteredRechtsformData = this.getFilteredRechtsformData() || [];

    if (this.cachedFilteredRechtsformData === filteredRechtsformData) {
      return this.cachedFlattenedRechtsformData;
    }
    this.cachedFilteredRechtsformData = filteredRechtsformData;
    this.cachedFlattenedRechtsformData = filteredRechtsformData.flatMap(
      (rechtsformDetail, groupIndex) =>
        (rechtsformDetail?.subHeaders || []).map((subHeader) => ({
          header: rechtsformDetail?.header || "",
          subHeader,
          groupOrder: groupIndex,
        }))
    );
    return this.cachedFlattenedRechtsformData;
  };

  getSelectedRechtsformHeader = () => {
    const selectedSubHeader = this.props?.formValues?.rechtsform?.value;

    // First try lookup based on selected rechtsform
    if (selectedSubHeader && this.props?.rechtsformData?.length) {
      const matchedOption = this.props.rechtsformData.find((item) =>
        item?.subHeaders?.includes(selectedSubHeader)
      );

      if (matchedOption?.header) {
        return matchedOption.header;
      }
    }

    // Fallback to backend value if available
    return this.props?.formValues?.rechtsformCategory?.value || "";
  };

  render() {
    const rechtsformOptions = this.getFlattenedRechtsformData();
    const previewHoveredClassBankOption =
      this.props.previewHoveredClassBankOption;
    const vorgangsart = this.props?.vorgangsart?.value;
    const isSteuerbefreiungPresent = this.props?.formValues?.steuerbefreiung
      ?.value
      ? true
      : false;
    const isNZRequest = vorgangsart === "NZ";
    const isTZRequest = vorgangsart === "TZ";
    const isSORequest = vorgangsart === "SO";
    const isReRegistrationRequest = ["UM", "WZ", "HA", "WG", "UG"].includes(
      vorgangsart
    ); // For ReRegistration either complex(UM) or simple(WZ)

    const isIndividualPerson =
      this.props.personenform.value === formConstants.individualPerson;

    const isVwagQesNp =
      isIndividualPerson &&
      isVWAGGroup() &&
      this.props?.vollmachtFormValues?.unterzeichnungsprozess?.value ===
        SIGNING_PROCESSING_TYPE.QES;

    const isJuristichePerson =
      this.props.personenform.value === formConstants.companyPerson;

    const nzAndNaturliche =
      isIndividualPerson &&
      (isNZRequest || isTZRequest || isReRegistrationRequest || isSORequest);

    const isNzAndNaturlicheReadOnly = nzAndNaturliche;

    // Halter identity fields (Vorname, Name, Geburtsname, Geburtsdatum,
    // Geburtsort) are editable in the manual-request QES flow.
    const isHalterFieldsWithNaturlicheReadOnly = false;

    const isPPOAorSelfEmployeed =
      this.props?.formValues?.halterAddress?.value === "individuelleAddresse" &&
      this.getSelectedRechtsformHeader() === RECHFORM_TYPE_SELF_EMPLOYED_PERSON;

    const { classes } = this.props;

    const steuerzahlweiseDisable = true;

    const disableAddressUploadCheckbox =
      this.props.readOnly ||
      this.props?.isVollmachtCompleted ||
      this.props?.showVollmachtAbbrechen ||
      this.checkAddressAndDocumentValidation();

    const adressnachweisView = !(
      this.props?.formValues?.halterAddress?.value ===
        this.props?.companyDetails?.name &&
      this.props.companyDetails?.tenantOwnsGKSNumber
    ) && (
      <div>
        <Grid container marginTop={"1rem"}>
          {
            <Grid item xs={12} className={classes.fieldGroup}>
              <MDCCheckbox
                name="addressDocumentCheckbox"
                label={ADDRESS_PROOF_CONFIRMATION_LABEL}
                checked={
                  isVwagQesNp ||
                  ((this.props.formValues.addressDocumentCheckbox.value ===
                    true ||
                    this.props.formValues.addressDocumentCheckbox.value ===
                      "true") &&
                    !this.checkAddressAndDocumentValidation())
                }
                onChange={(e) => this.props.handleChange(e, 3)}
                disabled={disableAddressUploadCheckbox}
                icon={
                  <AddressProofIcon
                    color={
                      disableAddressUploadCheckbox
                        ? theme.palette.MDCColors.textColor
                        : theme.palette.MDCColors.color23
                    }
                  />
                }
              />

              {!isVwagQesNp && (
                <ErrorText
                  id="addressDocumentCheckbox-error"
                  error={this.props.formValues?.addressDocumentCheckbox?.error}
                />
              )}
            </Grid>
          }

          {this.props.formValues?.addressDocumentVerifiedOn?.value && (
            <Grid marginTop={"1rem"} marginBottom={"1rem"}>
              Verifiziert am{" "}
              {moment(
                this.props.formValues?.addressDocumentVerifiedOn?.value
              ).format("DD.MM.YYYY")}{" "}
              {moment(
                this.props.formValues?.addressDocumentVerifiedOn?.value
              ).format("HH:mm:ss")}{" "}
              Uhr von {this.props.formValues?.addressDocumentVerifiedBy?.value}
            </Grid>
          )}

          <Grid item xs={12} marginY="1rem" className={classes.fieldGroup}>
            <AddressProofUpload
              isPPOAorSelfEmployeed={isPPOAorSelfEmployeed}
              isOptional
              documentName="addressDocument"
              uploadedFileData={this.props.formValues?.addressDocument?.value}
              handleChange={(event) => this.props.handleChange(event, 3)}
              error={this.props.formValues?.addressDocument?.error}
              columnTitle={classes.columnTitle}
              isVollmachtCompleted={this.props.isVollmachtCompleted}
              disabled={
                this.props.readOnly ||
                this.props?.isVollmachtCompleted ||
                this.props?.showVollmachtAbbrechen
              }
            />
          </Grid>
        </Grid>
      </div>
    );

    const anschriftView = (
      <div>
        <label className={classes.columnTitle}>
          Anschrift
          {this.props.isQESIconDisplay && (
            <VollmachtsRelevantIcon
              isQESCompleted={this.props.isVollmachtCompleted}
            />
          )}
        </label>
        <Grid container spacing={1}>
          <Grid item xs={6} className={classes.fieldGroup}>
            <MDCLabel label="Straße" />
            <MDCText
              name="Strasse"
              value={this.props.formValues.Strasse.value}
              onChange={(e) => this.props.handleChange(e, 3)}
              readOnly={
                this.props.readOnly ||
                this.props?.isVollmachtCompleted ||
                this.props?.showVollmachtAbbrechen
              }
              error={
                this.props.formValues?.Strasse?.error.length > 0 &&
                !this.props.readOnly
              }
              maxLength={40}
            />

            {this.props.formValues.Strasse.hasOwnProperty("duplicate") && (
              <DuplicateTextField
                name="Strasse"
                value={this.props.formValues.Strasse.duplicate}
                readOnly
                step={this.props.step}
                onAccept={() => this.props.resolveConflict("Strasse", true)}
                onReject={() => this.props.resolveConflict("Strasse", false)}
                maxLength={40}
              />
            )}
            {!this.props.readOnly && !this.props.isDetailDialog && (
              <ErrorText
                id="strasse-error"
                error={this.props.formValues.Strasse.error}
              />
            )}
          </Grid>

          <Grid item xs={6} className={classes.fieldGroup}>
            <MDCLabel label="Nummer" isOptional={isJuristichePerson} />
            <MDCText
              name="Hausnummer"
              value={this.props.formValues.Hausnummer.value}
              onChange={(e) => this.props.handleChange(e, 3)}
              inputProps={{ maxLength: 25 }}
              readOnly={
                this.props.readOnly ||
                this.props?.isVollmachtCompleted ||
                this.props?.showVollmachtAbbrechen
              }
              error={
                this.props.formValues?.Hausnummer?.error.length > 0 &&
                !this.props.readOnly
              }
              isToolTipText={
                this.props.readOnly || isNzAndNaturlicheReadOnly
                  ? this.props.formValues.Hausnummer.value
                  : ""
              }
              maxLength={25}
            />

            {this.props.formValues.Hausnummer.hasOwnProperty("duplicate") && (
              <DuplicateTextField
                name="Hausnummer"
                value={this.props.formValues.Hausnummer.duplicate}
                readOnly
                step={this.props.step}
                onAccept={() => this.props.resolveConflict("Hausnummer", true)}
                onReject={() => this.props.resolveConflict("Hausnummer", false)}
                maxLength={25}
              />
            )}
            {!this.props.readOnly && !this.props.isDetailDialog && (
              <ErrorText
                id="Hausnummer-error"
                error={this.props.formValues.Hausnummer.error}
              />
            )}
          </Grid>

          <Grid item xs={12} className={classes.fieldGroup}>
            <MDCLabel label="Postleitzahl" />
            <MDCText
              name="Postleitzahl"
              value={this.props.formValues.Postleitzahl.value}
              onChange={(e) => this.props.handleChange(e, 3)}
              readOnly={
                this.props.readOnly ||
                this.props?.isVollmachtCompleted ||
                this.props?.showVollmachtAbbrechen
              }
              error={
                this.props.formValues?.Postleitzahl?.error.length > 0 &&
                !this.props.readOnly
              }
              maxLength={10}
            />

            {this.props.formValues.Postleitzahl.hasOwnProperty("duplicate") && (
              <DuplicateTextField
                name="Postleitzahl"
                value={this.props.formValues.Postleitzahl.duplicate}
                readOnly
                step={this.props.step}
                onAccept={() =>
                  this.props.resolveConflict("Postleitzahl", true)
                }
                onReject={() =>
                  this.props.resolveConflict("Postleitzahl", false)
                }
                maxLength={10}
              />
            )}
            {!this.props.readOnly && !this.props.isDetailDialog && (
              <ErrorText
                id="postleitzahl-error"
                error={this.props.formValues.Postleitzahl.error}
              />
            )}
          </Grid>

          <Grid item xs={12} className={classes.fieldGroup}>
            <MDCLabel label="Stadt" />
            <MDCText
              name="Wohnort"
              value={this.props.formValues.Wohnort.value}
              onChange={(e) => this.props.handleChange(e, 3)}
              readOnly={
                this.props.readOnly ||
                this.props?.isVollmachtCompleted ||
                this.props?.showVollmachtAbbrechen
              }
              error={
                this.props.formValues?.Wohnort?.error.length > 0 &&
                !this.props.readOnly
              }
              maxLength={40}
            />

            {this.props.formValues.Wohnort.hasOwnProperty("duplicate") && (
              <DuplicateTextField
                name="Wohnort"
                value={this.props.formValues.Wohnort.duplicate}
                readOnly
                step={this.props.step}
                onAccept={() => this.props.resolveConflict("Wohnort", true)}
                onReject={() => this.props.resolveConflict("Wohnort", false)}
                maxLength={40}
              />
            )}
            {!this.props.readOnly && !this.props.isDetailDialog && (
              <ErrorText
                id="wohnort-error"
                error={this.props.formValues.Wohnort.error}
              />
            )}
          </Grid>
        </Grid>
      </div>
    );

    const steuermandatview = (
      <Grid item xs={12}>
        <div>
          <label className={classes.columnTitle}>Steuermandat</label>
          <Grid container>
            <Grid item xs={12} className={classes.fieldGroup}>
              <Grid marginTop={".3rem"}>
                <MDCLabel label="Steuerbefreiung" />
                <MDCSelectWithTooltip
                  name="steuerbefreiung"
                  placeholder="keine"
                  value={this.props?.formValues?.steuerbefreiung?.value}
                  handleChange={(e) => this.props.handleChange(e, 3)}
                  disabled={
                    this.props.readOnly ||
                    this.props.isVollmachtCompleted ||
                    this.props?.showVollmachtAbbrechen
                  }
                  error={
                    this.props.formValues?.steuerbefreiung?.error &&
                    !this.props.readOnly
                  }
                  options={this.props?.steuerbefreiungData?.data}
                />
                {!this.props.readOnly && !this.props.isDetailDialog && (
                  <ErrorText
                    id="steuerbefreiung-error"
                    error={this.props.formValues?.steuerbefreiung?.error}
                  />
                )}
              </Grid>
            </Grid>
            {!isSteuerbefreiungPresent && (
              <Grid item xs={12} className={classes.fieldGroup}>
                <Grid marginTop={".3rem"}>
                  <MDCLabel label="Zahlweise" />
                  <MDCSelect
                    name="steuerzahlweise"
                    value="jährlich"
                    handleChange={(e) => this.props.handleChange(e, 3)}
                    //for time being will always remain disabled with no error
                    disabled={
                      steuerzahlweiseDisable ||
                      this.props.readOnly ||
                      this.props.isVollmachtCompleted
                    }
                    // error={
                    //   this.props.formValues.steuerzahlweise.error &&
                    //   !this.props.readOnly
                    // }
                    options={steuerzahlweiseOptions}
                  />
                  {this.props.formValues.steuerzahlweise.hasOwnProperty(
                    "duplicate"
                  ) && (
                    <>
                      <DuplicateTextField
                        name="steuerzahlweise"
                        value={this.props.formValues.steuerzahlweise.duplicate}
                        readOnly
                        step={this.props.step}
                        onAccept={() =>
                          this.props.resolveConflict("steuerzahlweise", true)
                        }
                        onReject={() =>
                          this.props.resolveConflict("steuerzahlweise", false)
                        }
                      />
                    </>
                  )}
                  {/* {!this.props.readOnly && (
                    <ErrorText
                      id="steuerzahlweise-error"
                      error={this.props.formValues.steuerzahlweise.error}
                    />
                  )} */}
                </Grid>
              </Grid>
            )}
          </Grid>
        </div>
      </Grid>
    );
    const bankDetailsView = (
      <Grid>
        <label className={classes.columnTitle}>
          Bankverbindung Lastschrift Kfz-Steuer
          {this.props.isQESIconDisplay && (
            <VollmachtsRelevantIcon
              isQESCompleted={this.props.isVollmachtCompleted}
            />
          )}
        </label>
        <Grid container spacing={1}>
          <Grid item xs={12} className={classes.fieldGroup}>
            <MDCLabel label="Kontoinhaber" />
            <MDCText
              name="kontoinhaber"
              value={this.props.formValues.kontoinhaber.value}
              onChange={(e) => this.props.handleChange(e, 3)}
              readOnly={this.checkDisabilityForBankDetails()}
              error={
                this.props.formValues?.kontoinhaber?.error.length > 0 &&
                !this.props.readOnly
              }
              maxLength={70}
            />

            {this.props.formValues.kontoinhaber.hasOwnProperty("duplicate") && (
              <DuplicateTextField
                name="kontoinhaber"
                value={this.props.formValues.kontoinhaber.duplicate}
                readOnly
                step={this.props.step}
                onAccept={() =>
                  this.props.resolveConflict("kontoinhaber", true)
                }
                onReject={() =>
                  this.props.resolveConflict("kontoinhaber", false)
                }
                maxLength={70}
              />
            )}
            {!this.props.readOnly && !this.props.isDetailDialog && (
              <ErrorText
                id="kontoinhaber-error"
                error={this.props.formValues.kontoinhaber.error}
              />
            )}
          </Grid>

          <Grid item xs={12} className={classes.fieldGroup}>
            <MDCLabel label="IBAN" />
            <MDCIBANAutocompleteLookup
              name="iban"
              value={this.props.formValues.iban.value}
              setPreviewHoveredClassBankOption={
                this.props.setPreviewHoveredClassBankOption
              }
              isClassComponent
              onChange={(val) => {
                if (typeof val === "object") {
                  const bankDetails = {
                    nameBankverbindung: val?.kreditinstitut || "",
                    bic: val?.bic || "",
                  };
                  this.props.handleIbanBankDetailsChange(bankDetails);
                } else {
                  let event = {
                    target: {
                      name: "iban",
                      // Converting the IBAN value to uppercase as IBAN is not case sensitive but generally represented in uppercase and to avoid any mismatch with existing value in case sensitivity
                      value: val?.toUpperCase(),
                    },
                  };
                  this.props.handleChange(event, 3);
                }
              }}
              disabled={this.checkDisabilityForBankDetails()}
              error={
                this.props.formValues?.iban?.error.length > 0 &&
                !this.props.readOnly
              }
              maxLength={34}
            />

            {this.props.formValues.iban.hasOwnProperty("duplicate") && (
              <DuplicateTextField
                name="nameBankverbindung"
                value={this.props.formValues.iban.duplicate}
                readOnly
                step={this.props.step}
                onAccept={() => this.props.resolveConflict("iban", true)}
                onReject={() => this.props.resolveConflict("iban", false)}
                maxLength={34}
              />
            )}
            {!this.props.readOnly && !this.props.isDetailDialog && (
              <ErrorText
                id="iban-error"
                error={this.props.formValues.iban.error}
              />
            )}
          </Grid>

          <Grid item xs={12} className={classes.fieldGroup}>
            <MDCLabel label="Kreditinstitut" />
            <MDCText
              name="nameBankverbindung"
              value={
                previewHoveredClassBankOption?.kreditinstitut ||
                this.props.formValues.nameBankverbindung.value
              }
              onChange={(e) => this.props.handleChange(e, 3)}
              readOnly={this.checkDisabilityForBankDetails()}
              error={
                this.props.formValues?.nameBankverbindung?.error.length > 0 &&
                !this.props.readOnly
              }
              maxLength={255}
            />

            {this.props.formValues.nameBankverbindung.hasOwnProperty(
              "duplicate"
            ) && (
              <DuplicateTextField
                name="nameBankverbindung"
                value={this.props.formValues.nameBankverbindung.duplicate}
                readOnly
                step={this.props.step}
                onAccept={() =>
                  this.props.resolveConflict("nameBankverbindung", true)
                }
                onReject={() =>
                  this.props.resolveConflict("nameBankverbindung", false)
                }
                maxLength={255}
              />
            )}
            {!this.props.readOnly && !this.props.isDetailDialog && (
              <ErrorText
                id="nameBankverbindung-error"
                error={this.props.formValues.nameBankverbindung.error}
              />
            )}
          </Grid>

          <Grid item xs={12} className={classes.fieldGroup}>
            <MDCLabel label="BIC" />
            <MDCText
              name="bic"
              value={
                previewHoveredClassBankOption?.bic ||
                this.props.formValues.bic.value
              }
              onChange={(e) => this.props.handleChange(e, 3)}
              readOnly={this.checkDisabilityForBankDetails()}
              error={
                this.props.formValues?.bic?.error.length > 0 &&
                !this.props.readOnly
              }
              maxLength={11}
            />

            {this.props.formValues.bic.hasOwnProperty("duplicate") && (
              <DuplicateTextField
                name="bic"
                value={this.props.formValues.bic.duplicate}
                readOnly
                step={this.props.step}
                onAccept={() => this.props.resolveConflict("bic", true)}
                onReject={() => this.props.resolveConflict("bic", false)}
                maxLength={11}
              />
            )}
            {!this.props.readOnly && !this.props.isDetailDialog && (
              <ErrorText
                id="bic-error"
                error={this.props.formValues.bic.error}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    );

    const ZB1ZB2View = (
      <Grid item xs={12} marginTop={"1rem"}>
        <ZB1ZB2Addresses
          formValues={this.props.formValues}
          handleChange={this.props.handleChange}
          operationIdsOptions={this.props.operationIdsOptions}
          readOnly={this.props.readOnly}
          vorgangsart={this.props.vorgangsart}
          isVollmachtCompleted={this.props.isVollmachtCompleted}
          showVollmachtAbbrechen={this.props.showVollmachtAbbrechen}
          setZB1AddressInZB2={this.props.setZB1AddressInZB2}
          isZustellungZBError={this.props.isZustellungZBError}
          isDetailDialog={this.props.isDetailDialog}
          isQESIconDisplay={this.props.isQESIconDisplay}
          requestId={this.props?.requestId}
        />
      </Grid>
    );

    const getPPOADisconnectModalHeader = () => {
      return (
        <Grid container className={classes.headerCss}>
          <Grid item xs={7} className={classes.headerColor}>
            <h4>Bearbeiten</h4>
          </Grid>
          <Grid item xs={5} display={"flex"} justifyContent={"flex-end"}>
            <img alt="My Digital Car" src={carLogo} width={"95%"} />
          </Grid>
        </Grid>
      );
    };

    const getPPOADisconnectModalBody = () => {
      return (
        <Grid container className={classes.contentCss}>
          <Grid container justifyContent="center">
            <img src={DocumentIcon} />
          </Grid>
          <Grid container marginY="2rem">
            <p>{halterRequestFormConstants.PPOA_VOLLMACHT_DISCONNECT}</p>
          </Grid>
        </Grid>
      );
    };

    const getPPOADisconnectModalFooter = () => {
      return (
        <Grid container pb={3} paddingX={"2rem"} justifyContent="space-between">
          <Grid item>
            <MDCButton
              onClick={() => {
                this.setState({ openDisconnectPPOAModal: false });
              }}
              variant="outlined"
              label="Abbrechen"
            />
          </Grid>
          <Grid item>
            <MDCButton
              onClick={() => {
                this.setState({ openDisconnectPPOAModal: false });
                this.props.disconnectPPOA();
              }}
              variant="contained"
              label={"Bestätigen"}
              disabled={false}
            />
          </Grid>
        </Grid>
      );
    };

    return (
      <Grid container>
        <Grid
          item
          xs={12}
          className={`${classes.formBackGround} ${
            this.props.isDetailDialog ? classes.detailViewBackground : ""
          } ${
            this.props?.isVollmachtCompleted ? classes.vollmachtCompleted : ""
          }`}
        >
          {!this.props?.isDetailDialog && this.props?.isVollmachtCompleted && (
            <VollmachtLoschen
              handleModal={this.props.handleVollmachtLoschenChange}
              createNewRequest={this.props?.createNewRequest}
            />
          )}
          {!this.props?.isDetailDialog &&
            this.props?.showVollmachtAbbrechen && (
              <VollmachtAbbrechen
                handleModal={this.props.handleVollmachtAbbrechenChange}
              />
            )}

          <div>
            {!this.props.isDetailDialog && (
              <>{this.props.selectDuplicateValues()}</>
            )}

            {/* 0709 xml response messages */}
            {this.getGlobalMessagesView()}

            {!this.props.readOnly &&
              (this.props.vollmachtTabStatus ||
                !this.props.qesCompletedStage) &&
              this.getInfoMessage(
                halterRequestFormConstants.ADDRESS_FIELDS_BLANK_INFO_NP,
                classes
              )}

            {this.props.isPpoaApplied &&
              this.getPPOAInfoMessage(
                halterRequestFormConstants.PPOA_VOLLMACHT_INFO,
                classes
              )}

            <Grid container spacing={3} marginBottom="1%">
              {isJuristichePerson && (
                <Grid item xs={4}>
                  <label className={classes.columnTitle}>
                    Halter*in
                    {this.props.isQESIconDisplay && (
                      <VollmachtsRelevantIcon
                        isQESCompleted={this.props.isVollmachtCompleted}
                      />
                    )}
                  </label>
                  <>
                    <Grid item xs={12} className={classes.fieldGroup}>
                      <MDCLabel label="Haltertyp" />
                      <MDCSelect
                        value={this.props?.formValues?.halterAddress?.value}
                        name="halterAddress"
                        handleChange={(e) => this.props.handleChange(e, 3)}
                        disabled={
                          this.props?.isVollmachtCompleted ||
                          this.props?.showVollmachtAbbrechen ||
                          this.props?.readOnly
                        }
                        error={
                          this.props.formValues.halterAddress.error &&
                          !this.props.readOnly
                        }
                        options={this.getHalterAddressTypeOptions()}
                        placeholder={"Bitte auswählen"}
                      />

                      {!this.props.readOnly && !this.props.isDetailDialog && (
                        <ErrorText
                          id="halterAddress-error"
                          error={this.props.formValues.halterAddress?.error}
                        />
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      display={"flex"}
                      flexDirection={"column"}
                      marginY={"1rem"}
                    >
                      <MDCButton
                        variant="contained"
                        label={"Vollmachtsdatenbank öffnen"}
                        onClick={this.props.handleOpenVollmachtsDatenBank}
                        disabled={
                          this.checkForDisablingVollmachtPPOA() ||
                          this.props?.isVollmachtCompleted ||
                          this.props?.showVollmachtAbbrechen
                        }
                      />
                    </Grid>
                    {!(
                      this.props?.formValues?.halterAddress?.value ===
                        this.props?.companyDetails?.name &&
                      this.props.companyDetails?.tenantOwnsGKSNumber
                    ) && (
                      <Grid item xs={12} marginY="1rem">
                        <>
                          <MDCLabel label="Rechtsform " />
                          <MDCGroupedIconDropdown
                            showIcon
                            error={
                              this.props.formValues?.rechtsform?.error &&
                              !this.props.readOnly
                            }
                            options={rechtsformOptions}
                            value={
                              this.props?.formValues?.rechtsform?.value || ""
                            }
                            disabled={
                              this.props?.isVollmachtCompleted ||
                              this.props?.readOnly ||
                              this.props?.showVollmachtAbbrechen
                            }
                            onChange={(val) => {
                              let event = {
                                target: {
                                  name: "rechtsform",
                                  value: val,
                                },
                              };
                              this.props.handleChange(event, 3);
                            }}
                          />
                          {!this.props.readOnly &&
                            !this.props.isDetailDialog && (
                              <ErrorText
                                id="rechtsform-error"
                                error={this.props.formValues?.rechtsform?.error}
                              />
                            )}
                        </>
                      </Grid>
                    )}
                    {this.props?.formValues?.rechtsform?.value &&
                      !(
                        this.props?.formValues?.halterAddress?.value ===
                          this.props?.companyDetails?.name &&
                        this.props.companyDetails?.tenantOwnsGKSNumber
                      ) && (
                        <Grid item xs={12} className={classes.fieldGroup}>
                          <MDCText
                            name="rechtsformHeader"
                            value={this.getSelectedRechtsformHeader()}
                            readOnly
                          />
                        </Grid>
                      )}
                    <Grid item xs={12} marginY="1.5rem">
                      <Grid container justifyContent={"space-between"}>
                        <Grid item alignSelf={"end"}>
                          <MDCLabel label="Wirtschaftszweig" />
                        </Grid>
                        <Grid item padding="0 !important">
                          <Link
                            className={this.props?.classes?.linkStyles}
                            component="button"
                            color="inherit"
                            variant="body1"
                            onClick={() => this.downloadWirtschaftsTemplate()}
                          >
                            <DownloadFileIcon
                              className={
                                this.props?.classes?.downloadFileIconStyles
                              }
                            />
                            Wirtschaftszweigübersicht.pdf
                          </Link>
                        </Grid>
                      </Grid>

                      <MDCGroupedDropdown
                        error={
                          this.props.formValues?.SchluesselBeruf?.error &&
                          !this.props.readOnly
                        }
                        options={this.props?.wirtschaftsData?.data}
                        value={this.getAutoCompleteDropDownValue(
                          this.props.formValues?.SchluesselBeruf?.value,
                          this.props?.wirtschaftsData?.data
                        )}
                        disabled={
                          this.props?.isVollmachtCompleted ||
                          this.props?.readOnly ||
                          this.props?.showVollmachtAbbrechen
                        }
                        onChange={(val) => {
                          let event = {
                            target: {
                              name: "SchluesselBeruf",
                              value: val,
                            },
                          };
                          this.props.handleChange(event, 3);
                        }}
                        placeholder={"Bitte auswählen"}
                      />
                      {!this.props.readOnly && !this.props.isDetailDialog && (
                        <ErrorText
                          id="SchluesselBeruf-error"
                          error={this.props.formValues?.SchluesselBeruf?.error}
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} marginY="1rem">
                      {this.props.formValues.halterAddress.value ===
                        "individuelleAddresse" &&
                        this.getSelectedRechtsformHeader() !==
                          RECHFORM_TYPE_SELF_EMPLOYED_PERSON && (
                          <>
                            <MDCLabel label="Haltername " />
                            <MDCText
                              name="NameJuristischePerson"
                              value={
                                this.props.formValues.NameJuristischePerson
                                  .value
                              }
                              onChange={(e) => this.props.handleChange(e, 3)}
                              readOnly={
                                this.props.readOnly ||
                                this.props?.isVollmachtCompleted ||
                                this.props?.isDetailDialog ||
                                this.props?.showVollmachtAbbrechen
                              }
                              error={
                                !this.props?.isDetailDialog &&
                                this.props.formValues?.NameJuristischePerson
                                  ?.error.length > 0
                              }
                              maxLength={150}
                            />
                            {!this.props.readOnly &&
                              !this.props.isDetailDialog && (
                                <ErrorText
                                  id="nameJuristischePerson-error"
                                  error={
                                    this.props.formValues.NameJuristischePerson
                                      .error
                                  }
                                />
                              )}
                          </>
                        )}
                      {this.getSelectedRechtsformHeader() ===
                        RECHFORM_TYPE_SELF_EMPLOYED_PERSON &&
                        this.props.formValues.halterAddress.value ===
                          "individuelleAddresse" && (
                          <>
                            <Grid container spacing={1}>
                              <Grid item xs={6} className={classes.fieldGroup}>
                                <MDCLabel label="Vorname" />
                                <MDCText
                                  name="vorname"
                                  value={this.props.formValues.vorname.value}
                                  onChange={(e) =>
                                    this.props.handleChange(e, 3)
                                  }
                                  readOnly={
                                    this.props?.isVollmachtCompleted ||
                                    this.props.readOnly ||
                                    isHalterFieldsWithNaturlicheReadOnly
                                  }
                                  error={
                                    !isHalterFieldsWithNaturlicheReadOnly &&
                                    this.props.formValues?.vorname?.error
                                      .length > 0
                                  }
                                  maxLength={60}
                                />
                                {!this.props.readOnly &&
                                  !this.props.isDetailDialog && (
                                    <ErrorText
                                      id="vorname-error"
                                      error={
                                        !isHalterFieldsWithNaturlicheReadOnly &&
                                        this.props.formValues.vorname.error
                                      }
                                    />
                                  )}
                              </Grid>

                              <Grid item xs={6} className={classes.fieldGroup}>
                                <MDCLabel label="Name" />
                                <MDCText
                                  name="auskunft_NatuerlichePerson_FamiliennameNachname"
                                  value={
                                    this.props.formValues
                                      .auskunft_NatuerlichePerson_FamiliennameNachname
                                      .value
                                  }
                                  onChange={(e) =>
                                    this.props.handleChange(e, 3)
                                  }
                                  readOnly={
                                    this.props?.isVollmachtCompleted ||
                                    this.props.readOnly ||
                                    isHalterFieldsWithNaturlicheReadOnly
                                  }
                                  error={
                                    !isHalterFieldsWithNaturlicheReadOnly &&
                                    this.props.formValues
                                      ?.auskunft_NatuerlichePerson_FamiliennameNachname
                                      ?.error?.length > 0
                                  }
                                  maxLength={45}
                                />
                                {!this.props.readOnly &&
                                  !this.props.isDetailDialog && (
                                    <ErrorText
                                      id="name-error"
                                      error={
                                        !isHalterFieldsWithNaturlicheReadOnly &&
                                        this.props.formValues
                                          ?.auskunft_NatuerlichePerson_FamiliennameNachname
                                          ?.error
                                      }
                                    />
                                  )}
                              </Grid>

                              <Grid item xs={6} className={classes.fieldGroup}>
                                <div>
                                  <MDCLabel label="Geschlecht" />
                                </div>

                                <MDCSelect
                                  name="geschlecht"
                                  value={this.props.formValues.geschlecht.value}
                                  handleChange={(e) =>
                                    this.props.handleChange(e, 3)
                                  }
                                  disabled={
                                    this.props.readOnly ||
                                    this.props?.isVollmachtCompleted ||
                                    isHalterFieldsWithNaturlicheReadOnly
                                  }
                                  error={
                                    !isHalterFieldsWithNaturlicheReadOnly &&
                                    this.props.formValues?.geschlecht?.error
                                      .length > 0
                                  }
                                  options={GeschlechtOptions}
                                  isSmall
                                />
                                {!this.props.readOnly &&
                                  !this.props.isDetailDialog && (
                                    <ErrorText
                                      id="vorname-error"
                                      error={
                                        !isHalterFieldsWithNaturlicheReadOnly &&
                                        this.props.formValues.geschlecht.error
                                      }
                                    />
                                  )}
                              </Grid>

                              <Grid item xs={6} className={classes.fieldGroup}>
                                <MDCLabel label="Geburtsdatum" />
                                <div className={classes.fieldGroupMargin}>
                                  <MDCDatePicker
                                    isManualEntry
                                    maxDate={new Date()}
                                    value={
                                      this.props.formValues.geburtstag?.value &&
                                      moment(
                                        this.props.formValues.geburtstag.value,
                                        "YYYYMMDD"
                                      ).format("YYYY-MM-DD")
                                    }
                                    onChange={(date) => {
                                      let event = {
                                        target: {
                                          name: "geburtstag",
                                          type: "date",
                                          value:
                                            date !== null
                                              ? dbFormatDate(date, "")
                                              : null,
                                        },
                                      };
                                      this.props.handleChange(event, 3);
                                    }}
                                    readOnly={
                                      this.props.readOnly ||
                                      this.props?.isVollmachtCompleted ||
                                      isHalterFieldsWithNaturlicheReadOnly
                                    }
                                    error={
                                      !isHalterFieldsWithNaturlicheReadOnly &&
                                      this.props.formValues?.geburtstag?.error
                                        .length > 0
                                    }
                                  />
                                  {!this.props.readOnly &&
                                    !this.props.isDetailDialog && (
                                      <ErrorText
                                        id="geburtstag-error"
                                        error={
                                          !isHalterFieldsWithNaturlicheReadOnly &&
                                          this.props.formValues.geburtstag.error
                                        }
                                      />
                                    )}
                                </div>
                              </Grid>
                              <Grid item xs={12} className={classes.fieldGroup}>
                                <MDCLabel label="Geburtsort" />
                                <MDCText
                                  name="geburtsort"
                                  value={this.props.formValues.geburtsort.value}
                                  onChange={(e) =>
                                    this.props.handleChange(e, 3)
                                  }
                                  readOnly={
                                    this.props.readOnly ||
                                    this.props?.isVollmachtCompleted ||
                                    isHalterFieldsWithNaturlicheReadOnly
                                  }
                                  error={
                                    !isHalterFieldsWithNaturlicheReadOnly &&
                                    this.props.formValues?.geburtsort?.error
                                      .length > 0
                                  }
                                  maxLength={40}
                                />
                                {!this.props.readOnly &&
                                  !this.props.isDetailDialog && (
                                    <ErrorText
                                      id="geburtsort-error"
                                      error={
                                        !isHalterFieldsWithNaturlicheReadOnly &&
                                        this.props.formValues.geburtsort.error
                                      }
                                    />
                                  )}
                              </Grid>
                            </Grid>
                          </>
                        )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      marginTop={
                        this.props.formValues.halterAddress.value ===
                        "individuelleAddresse"
                          ? "1.75rem"
                          : "6.8rem"
                      }
                    >
                      <Grid marginBottom={".5rem"}>
                        {anschriftView} {adressnachweisView}
                      </Grid>
                    </Grid>
                  </>
                </Grid>
              )}
              {nzAndNaturliche && (
                <Grid item xs={4}>
                  <div>
                    <label className={classes.columnTitle}>
                      Halter*in
                      {this.props.isQESIconDisplay && (
                        <VollmachtsRelevantIcon
                          isQESCompleted={this.props.isVollmachtCompleted}
                        />
                      )}
                    </label>
                    <Grid container spacing={0.5}>
                      {this.props.personenform.value ===
                        formConstants.individualPerson && (
                        <>
                          <Grid item xs={6} className={classes.fieldGroup}>
                            <MDCLabel label="Vorname" />
                            <MDCText
                              name="vorname"
                              value={this.props.formValues.vorname.value}
                              onChange={(e) => this.props.handleChange(e, 3)}
                              readOnly={
                                this.props.readOnly ||
                                isVwagQesNp ||
                                isHalterFieldsWithNaturlicheReadOnly ||
                                this.props.showVollmachtAbbrechen ||
                                this.props.isDetailDialog ||
                                this.props.isVollmachtCompleted
                              }
                              error={
                                !isVwagQesNp &&
                                !isHalterFieldsWithNaturlicheReadOnly &&
                                !isVwagQesNp &&
                                this.props.formValues?.vorname?.error.length > 0
                              }
                              maxLength={60}
                            />
                            {!this.props.readOnly &&
                              !this.props.isDetailDialog &&
                              !isVwagQesNp && (
                                <ErrorText
                                  id="vorname-error"
                                  error={
                                    !isHalterFieldsWithNaturlicheReadOnly &&
                                    this.props.formValues.vorname.error
                                  }
                                />
                              )}
                          </Grid>

                          <Grid item xs={6} className={classes.fieldGroup}>
                            <MDCLabel label="Name" />
                            <MDCText
                              name="auskunft_NatuerlichePerson_FamiliennameNachname"
                              value={
                                this.props?.formValues
                                  ?.auskunft_NatuerlichePerson_FamiliennameNachname
                                  ?.value
                              }
                              onChange={(e) => this.props.handleChange(e, 3)}
                              readOnly={
                                this.props.readOnly ||
                                isVwagQesNp ||
                                isHalterFieldsWithNaturlicheReadOnly ||
                                this.props.showVollmachtAbbrechen ||
                                this.props.isDetailDialog ||
                                this.props.isVollmachtCompleted
                              }
                              error={
                                !isVwagQesNp &&
                                !isHalterFieldsWithNaturlicheReadOnly &&
                                !isVwagQesNp &&
                                this.props?.formValues
                                  ?.auskunft_NatuerlichePerson_FamiliennameNachname
                                  ?.error.length > 0
                              }
                              maxLength={45}
                            />
                            {!this.props.readOnly &&
                              !this.props.isDetailDialog &&
                              !isVwagQesNp && (
                                <ErrorText
                                  id="name-error"
                                  error={
                                    !isHalterFieldsWithNaturlicheReadOnly &&
                                    this.props?.formValues
                                      ?.auskunft_NatuerlichePerson_FamiliennameNachname
                                      ?.error
                                  }
                                />
                              )}
                          </Grid>

                          {nzAndNaturliche && (
                            <>
                              <Grid item xs={12} className={classes.fieldGroup}>
                                <MDCLabel label="Geburtsname" />
                                <MDCText
                                  name="geburtsnameNachname"
                                  value={
                                    this.props.formValues.geburtsnameNachname
                                      .value
                                  }
                                  onChange={(e) =>
                                    this.props.handleChange(e, 3)
                                  }
                                  readOnly={
                                    this.props.readOnly ||
                                    isVwagQesNp ||
                                    isHalterFieldsWithNaturlicheReadOnly ||
                                    this.props?.showVollmachtAbbrechen ||
                                    this.props.isDetailDialog ||
                                    this.props.isVollmachtCompleted
                                  }
                                  error={
                                    !isVwagQesNp &&
                                    !isHalterFieldsWithNaturlicheReadOnly &&
                                    !isVwagQesNp &&
                                    this.props.formValues?.geburtsnameNachname
                                      ?.error.length > 0
                                  }
                                  maxLength={45}
                                />
                                {!this.props.readOnly &&
                                  !this.props.isDetailDialog &&
                                  !isVwagQesNp && (
                                    <ErrorText
                                      id="geburtsnameNachname-error"
                                      error={
                                        !isHalterFieldsWithNaturlicheReadOnly &&
                                        this.props.formValues
                                          ?.geburtsnameNachname?.error
                                      }
                                    />
                                  )}
                              </Grid>

                              <Grid item xs={6} className={classes.fieldGroup}>
                                <div>
                                  <MDCLabel label="Geschlecht" />
                                  {this.props.isQESIconDisplay && (
                                    <VollmachtsRelevantIcon
                                      isQESCompleted={
                                        this.props.isVollmachtCompleted
                                      }
                                    />
                                  )}
                                </div>

                                <MDCSelect
                                  name="geschlecht"
                                  value={this.props.formValues.geschlecht.value}
                                  handleChange={(e) =>
                                    this.props.handleChange(e, 3)
                                  }
                                  disabled={
                                    this.props.readOnly ||
                                    this.props?.isVollmachtCompleted ||
                                    this.props?.showVollmachtAbbrechen ||
                                    this.props.isDetailDialog
                                  }
                                  error={
                                    this.props.formValues?.geschlecht?.error
                                      .length > 0
                                  }
                                  options={GeschlechtOptions}
                                  isSmall
                                />
                                {!this.props.readOnly &&
                                  !this.props.isDetailDialog && (
                                    <ErrorText
                                      id="vorname-error"
                                      error={
                                        this.props.formValues.geschlecht.error
                                      }
                                    />
                                  )}
                              </Grid>

                              <Grid item xs={6} className={classes.fieldGroup}>
                                <MDCLabel label="Geburtsdatum" />
                                <div className={classes.fieldGroupMargin}>
                                  <MDCDatePicker
                                    isManualEntry
                                    maxDate={new Date()}
                                    value={
                                      this.props.formValues.geburtstag?.value &&
                                      moment(
                                        this.props.formValues.geburtstag.value,
                                        "YYYYMMDD"
                                      ).format("YYYY-MM-DD")
                                    }
                                    onChange={(date) => {
                                      let event = {
                                        target: {
                                          name: "geburtstag",
                                          type: "date",
                                          value:
                                            date !== null
                                              ? dbFormatDate(date, "")
                                              : null,
                                        },
                                      };
                                      this.props.handleChange(event, 3);
                                    }}
                                    readOnly={
                                      this.props.readOnly ||
                                      isVwagQesNp ||
                                      isHalterFieldsWithNaturlicheReadOnly ||
                                      this.props?.showVollmachtAbbrechen ||
                                      this.props.isDetailDialog ||
                                      this.props.isVollmachtCompleted
                                    }
                                    error={
                                      !isVwagQesNp &&
                                      !isHalterFieldsWithNaturlicheReadOnly &&
                                      !isVwagQesNp &&
                                      this.props.formValues?.geburtstag?.error
                                        .length > 0
                                    }
                                  />
                                  {!this.props.readOnly &&
                                    !this.props.isDetailDialog &&
                                    !isVwagQesNp && (
                                      <ErrorText
                                        id="geburtstag-error"
                                        error={
                                          !isHalterFieldsWithNaturlicheReadOnly &&
                                          this.props.formValues.geburtstag.error
                                        }
                                      />
                                    )}
                                </div>
                              </Grid>
                              <Grid item xs={12} className={classes.fieldGroup}>
                                <MDCLabel label="Geburtsort" />
                                <MDCText
                                  name="geburtsort"
                                  value={this.props.formValues.geburtsort.value}
                                  onChange={(e) =>
                                    this.props.handleChange(e, 3)
                                  }
                                  readOnly={
                                    this.props.readOnly ||
                                    isVwagQesNp ||
                                    isHalterFieldsWithNaturlicheReadOnly ||
                                    this.props?.showVollmachtAbbrechen ||
                                    this.props.isDetailDialog ||
                                    this.props.isVollmachtCompleted
                                  }
                                  error={
                                    !isHalterFieldsWithNaturlicheReadOnly &&
                                    !isVwagQesNp &&
                                    this.props.formValues?.geburtsort?.error
                                      .length > 0
                                  }
                                  maxLength={40}
                                />
                                {!this.props.readOnly &&
                                  !this.props.isDetailDialog &&
                                  !isVwagQesNp && (
                                    <ErrorText
                                      id="geburtsort-error"
                                      error={
                                        !isHalterFieldsWithNaturlicheReadOnly &&
                                        this.props.formValues.geburtsort.error
                                      }
                                    />
                                  )}
                              </Grid>
                            </>
                          )}
                        </>
                      )}
                    </Grid>
                  </div>
                </Grid>
              )}

              <Grid item xs={4}>
                <div>
                  {nzAndNaturliche && (
                    <>
                      {anschriftView} {adressnachweisView}
                    </>
                  )}
                  {(isNZRequest ||
                    isTZRequest ||
                    isSORequest ||
                    isReRegistrationRequest) &&
                    this.props.personenform.value ===
                      formConstants.individualPerson && (
                      <>
                        <Grid>
                          {steuermandatview} {ZB1ZB2View}
                        </Grid>
                      </>
                    )}

                  {isJuristichePerson && (
                    <>
                      <label className={classes.columnTitle}>
                        Zollgroßkundennummer
                        {this.props.isQESIconDisplay && (
                          <VollmachtsRelevantIcon
                            isQESCompleted={this.props.isVollmachtCompleted}
                          />
                        )}
                      </label>
                      <Grid
                        marginY={
                          this.props.isDetailDialog ? "1.3rem" : "1.75rem"
                        }
                      >
                        <Grid item xs={12} className={classes.fieldGroup}>
                          <MDCCheckbox
                            name="Vorhanden"
                            label="Zollgroßkundennummer vorhanden"
                            checked={this.props.formValues.Vorhanden.value}
                            onChange={(e) => this.props.handleChange(e, 3)}
                            disabled={
                              this.props.readOnly ||
                              this.props?.isVollmachtCompleted ||
                              this.props?.showVollmachtAbbrechen
                            }
                          />
                        </Grid>
                        <Grid item xs={12} className={classes.fieldGroup}>
                          <MDCLabel label="Zollgroßkundennummer des Halters" />
                          <MDCText
                            name="kundennummerdeshalters"
                            value={
                              this.props.formValues.kundennummerdeshalters.value
                            }
                            onChange={(e) => this.props.handleChange(e, 3)}
                            readOnly={
                              this.props.readOnly ||
                              !this.props.formValues.Vorhanden.value ||
                              this.props?.isVollmachtCompleted ||
                              this.props?.showVollmachtAbbrechen
                            }
                            error={
                              this.props.formValues?.kundennummerdeshalters
                                ?.error.length > 0
                            }
                            maxLength={8}
                          />
                          {!this.props.readOnly &&
                            !this.props.isDetailDialog && (
                              <ErrorText
                                id="nameJuristischePerson-error"
                                error={
                                  this.props.formValues.kundennummerdeshalters
                                    .error
                                }
                              />
                            )}
                        </Grid>
                      </Grid>

                      <Grid item xs={12} marginTop="2rem">
                        {bankDetailsView}
                      </Grid>
                    </>
                  )}
                </div>
              </Grid>

              {(isNZRequest ||
                isTZRequest ||
                isSORequest ||
                isReRegistrationRequest) && (
                <Grid item xs={4}>
                  {this.props.personenform.value !== "naturliche" && (
                    <>
                      <Grid>{steuermandatview}</Grid>
                      {this.props?.isVollmachtCompleted && (
                        <Grid marginTop={"1rem"}>
                          <label className={classes.columnTitle}>
                            Gesetztlicher Vertreter
                          </label>
                          <RepresentativeInfo
                            personData={this.getQESRepresentativeInfoData()}
                          />
                        </Grid>
                      )}
                      {ZB1ZB2View}
                    </>
                  )}
                  {isIndividualPerson && <>{bankDetailsView}</>}
                </Grid>
              )}
            </Grid>
          </div>
        </Grid>

        {/* PPOA vollmacht Reset Popup */}
        <MDCModal
          open={this.state.openDisconnectPPOAModal}
          title={getPPOADisconnectModalHeader()}
          body={getPPOADisconnectModalBody()}
          footer={getPPOADisconnectModalFooter()}
          size={"md"}
          isScroll
        />
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    wirtschaftsPDF: state.manualRequestFormReducer.wirtschaftsPDF,
    rechtsformData: state.manualRequestFormReducer.rechtsformData,
    wirtschaftsData: state.manualRequestFormReducer.wirtschaftsData,
    steuerbefreiungData: state.manualRequestFormReducer.steuerbefreiungData,
    companyDetails: state?.authentication?.companyDetails,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    downloadWirtschaftsPDF: () =>
      dispatch(manualRequestFormActions.downloadWirtschaftsPDF()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(HalterRequestForm));
